<div class="flex flex-row justify-content-between align-items-center py-3">
  <div class="flex-grow-1">
    <p-autoComplete #autocomplete
                    dataKey="id"
                    optionLabel="name"
                    [unique]="true"
                    [multiple]="true"
                    [forceSelection]="true"
                    [suggestions]="suggestions"
                    (completeMethod)="filterItems($event)"
                    [minLength]="1"
                    [placeholder]="placeholder"
                    [disabled]="requestInProcess"
                    [showEmptyMessage]="true"
                    emptyMessage="No keywords found"
                    i18n-emptyMessage
                    class="w-full">
      <ng-template let-value
                   pTemplate="selectedItem">
        <span [innerHTML]="value.name | safeMessage:'html'"></span>
      </ng-template>

      <ng-template let-value
                   pTemplate="item">
        <span [innerHTML]="value.name | safeMessage:'html'"></span>
      </ng-template>
    </p-autoComplete>
  </div>

  @if (buttonsVisible) {
    <div class="ml-3 flex-shrink-0">
      <p-button icon="pi pi-times"
                class="mr-2"
                styleClass="p-button-rounded p-button-outlined sc-small-icon-button"
                (onClick)="clearAutocomplete()"
                [disabled]="requestInProcess"
                pTooltip="Clear"
                tooltipPosition="top"
                [showDelay]="500"
                i18n-pTooltip>
      </p-button>
      <p-button (onClick)="addItems()"
                [loading]="requestInProcess"
                icon="pi pi-check"
                styleClass="p-button-rounded p-button-outlined p-button-success sc-small-icon-button"
                pTooltip="Add"
                tooltipPosition="top"
                [showDelay]="500"
                i18n-pTooltip>
      </p-button>
    </div>
  }
</div>